<template>
	<a v-if="!usuarioLogado" href="https://www.informaticasg.com.br" target="_blank" rel="noopener noreferrer">
		<div
			class="footer-fixed pl-1 pr-1"
			v-bind:style="usuarioLogado ? `left: ${Math.floor(sideBarWidth) + 0}px;` : 'left: 0px'"
		>
			<div class="container-enterprise">
				<h2>
					<span class="name">Informática</span>
					<span class="last-name">SG</span>
				</h2>
				<p class="slogan">Soluções de TI na ponta dos seus dedos</p>
			</div>
		</div>
	</a>
</template>

<script>
	import { mapState } from "vuex";
	export default {
		name: "EnterpriseName",
		props: {
			width: {
				type: String
			},
			fluid: {
				type: Boolean,
				default: false
			}
		},
		computed: mapState(["sideBarWidth", "usuarioLogado"])
	};
</script>

<style scoped>
	.hero-header {
		position: absolute;
		font-size: .9rem !important;
		color: white;
		align-items: flex-end;
		margin-top: 1.25rem;
		transition: all ease 0.5s;
	}

	.last-name {
		margin-left: 2px;
	}

	.slogan {
		margin-left: 3px;
		font-style: italic;
	}

	.container-enterprise {
		display: flex;
		align-items: baseline;
	}

	.footer-fixed {
		position: fixed;
		bottom: -14px;
		z-index: 998;
		color: rgb(196, 194, 194);
		cursor: pointer;
	}

	.footer-fixed:hover {
		color: rgb(255, 255, 255);
	}
</style>